export const FORM_NAMES = {
  LAAR: 'lightning_arrester_inspection_and_test_report',
  HVCB: 'high_voltage_cable_test_report',
  SF6V: 'sf_6_vista_switch_inspection_test_report',
  DFTR: 'dry_transformer_inspection_report',
  PBDC: 'panelboard_test_report',
  OFTR: 'oil_transformer_inspection_test_report',
}

export const COMPLEX_STRUCTURED_FORM_NAMES = {
  LVCB: 'low_voltage_circuit_breaker_test_report',
  MFOR: 's_c_multifunction_overcurrent_relay_test_report',
  HVCS: 'high_voltage_cable_test_report',
  BUDC: `${process.env.REACT_APP_BUDC}`,
  RELA_LG: 'relay',
  FSGR: 'ground_fault_system_test_report',
  GRCB: 'molded_case_thermal_magnetic_circuit_breaker_test_report',
  CITR: 'current_transformer_inspection_test_report',
}
